module.exports = __webpack_public_path__ + "img/2021_04_dande_korea_fin_web.ed45afd1.jpg";